const BASE_URL = process.env.REACT_APP_API_GATEWAY_URL
const COGNITO_BASE_URL = process.env.REACT_APP_COGNITO_URL
export const WEB_URL = process.env.REACT_APP_WEB_URL
const IDP_PROVIDER_NAME = process.env.REACT_APP_IDP_PROVIDER_NAME
const CLIENT_ID = process.env.REACT_APP_IDP_CLIENT_ID
export const USE_EXTERNAL_IDP = process.env.REACT_APP_USE_EXTERNAL_IDP
export const USE_CASS_MODULE = process.env.REACT_APP_USE_CASS_MODULE
export const DIGITIZED_PROTOCOL_MODULE = process.env.REACT_APP_DIGITIZED_PROTOCOL_MODULE

// Cognito configuration details
export const COGNITO_CONFIG = {
    client_id: CLIENT_ID,
    redirect_uri:`${WEB_URL}`,
    scope: `openid ${BASE_URL}`,
    response_type: 'code',
    identity_provider: IDP_PROVIDER_NAME
}

export const AUTHORIZE_URL = COGNITO_BASE_URL + "/oauth2/authorize"

export const COGNITO_LOGIN_URL = COGNITO_BASE_URL + "/login"

export const COGNITO_TOKEN_URL = COGNITO_BASE_URL + "/oauth2/token"

export const USERINFO_URL = COGNITO_BASE_URL + "/oauth2/userInfo"

export const REVOKE_URL = COGNITO_BASE_URL + "/oauth2/revoke"

export const COGNITO_LOGOUT_URL = `${COGNITO_BASE_URL}/logout?client_id=${CLIENT_ID}&logout_uri=${WEB_URL}`

export const PWCID_LOGOUT_URL = `https://login-stg.pwc.com/openam/XUI/#logout&goto=${WEB_URL}`

// Required for Content Security Policy
export const INACTIVITY_TIMEOUT = 15 * 60 * 1000; // 15 minute timeout
// export const INACTIVITY_TIMEOUT = 12 * 60 * 60 * 1000; // 12 hour timeout

export const LIST_ALL_TRIAL_URL = "/api/trial/list_all_trials"

export const GET_TRIAL_URL = "/api/trial/get_trial"

export const UPDATE_TRIAL_URL = "/api/trial/update_trial"

export const DELETE_TRIAL_URL = "/api/trial/delete_trial"

export const CALCULATE_MEAN_COST_URL = "/api/calculate_mean_cost"

export const CHECK_CREATE_TRIAL_STATUS_URL = "/api/check_create_trial_status"

export const CHECK_PATIENT_FUNNEL_STATUS_URL = "/api/check_patient_funnel_status"

export const GENERATE_CRITERIA_LIBRARY_URL = "/api/generate_criteria_library"

export const GET_CRITERIA_LIBRARY_URL = "/api/get_criteria_library"

export const GET_IE_RESOURCES_URL = "/api/get_ie_resources"

export const GET_PATIENT_FUNNEL_URL = "/api/get_patient_funnel"

export const GET_SOA_EVENT_LIBRARY_URL = "/api/get_soa_library"

export const GET_SOA_RESOURCES_URL = "/api/get_soa_resources"

export const GET_REFERENCE_DATA_URL = "/api/get_reference_data"

export const LIST_SIMILAR_HISTORICAL_TRIAL_URL = "/api/list_similar_historical_trial"

export const ADD_TRIAL_URL = "/api/trial/create_trial"

export const SAVE_TRIAL_SOA_URL = "/api/save_trial_soa"

export const SAVE_CHART_CONFIG_URL = "/api/trial/save_chart_configuration"

export const LIST_MEMBERS_URL= "/api/listMembers"

export const CREATE_SCENARIO_URL = "/api/trial/create_scenario"

export const SAVE_CRITERIA_URL = "/api/save_trial_criteria"

export const SAVE_TEMPLATE_SCENARIO_URL = "/api/trial/save_template_scenario"

export const GET_TRIAL_IE_CRITERIA = "/api/trial/get_trial_ie_criteria"

export const GET_TRIAL_SOA = "/api/trial/get_trial_soa"

export const CLINICAL_TRIALS_GOV_URL = "https://clinicaltrials.gov/study/"

export const GET_TRIAL_SOA_INSIGHTS = "/api/trial/get_trial_soa_insights"

export const GET_TRIAL_SOA_SB_INSIGHTS = "/api/trial/get_trial_soa_sb_insights"

export const LOGOUT_URL = "/api/logout"

export const GET_PROTOCOL_COMPLEXITY = "/api/trial/get_protocol_complexity"

export const GET_CHARTS_DATA = "/api/trial/get_charts_data"

export const GET_TRIAL_ENDPOINTS = "/api/trial/get_trial_endpoint"

export const GET_ENDPOINT_LIBRARY = "/api/trial/get_endpoint_library"

export const SAVE_ENDPOINT = "/api/trial/save_endpoint"

export const GET_TRIAL_PRESET = "/api/trial/get_trial_preset"

export const SAVE_TRIAL_PRESET = "/api/trial/save_trial_preset"